import React from 'react';
import { useSelector } from 'react-redux';

const Loading = () => {
	const loading = useSelector(state => state.loading);

	const style = {
		position: 'fixed',
		top: 0,
		left: 0,
		width: '100%',
		height: '100%',
		background: 'rgba(0, 0, 0, 0.4)'
	};

	return (
		<div
			className='justify-content-center align-items-center flex-grow-1 w-100 min-vh-100 position-fixed top-0 left:0'
			style={{
				display: loading ? 'flex' : 'none',
				zIndex: 9999
			}}
		>
			<div className='overlay' style={style}></div>
			<div className='spinner-grow text-primary color-mode' role='status'>
				<span className='visually-hidden'>Loading...</span>
			</div>
		</div>
	);
};

export default Loading;
